import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import LoginForm from '../Blocks/LoginForm';
import Logos from '../Blocks/Logos';

import imgPrimeGlobal from '../images/prime-global.png';
import imgIcon1 from '../images/about-icon-1.png';
// import imgIcon2 from '../images/about-icon-2.png';
import imgIcon3 from '../images/about-icon-3.png';
// import imgIcon4 from '../images/about-icon-4.png';


const home = (props) => {

	let loginBlock = <LoginForm flair='white' />;

	if(props.user !== null) {
		loginBlock = (
			<div className='account-form account-form--white'>
				<h5 className='account-form__title'>Welcome back, {props.user.alias}</h5>
				<div className='account-form__control'>
					<NavLink to='/dashboard' className='btn'>Dashboard</NavLink>
					&nbsp; <NavLink to='/logout' className='btn btn--grey'>Logout</NavLink>
				</div>
			</div>
		);
	}

	return (
		<div className='page'>

			<Logos />

			<section className='page__section page__section--white'>

				<div className='wrapper wrapper--narrow clearfix'>

					<div className='page__section__w30 pull-right--medium'>
						{loginBlock}
					</div>

					<div className='page__content'>

						<p>Navigating a commercial settlement is often a complicated process. For the client a particular dilemma is the uncertainty about their position in the litigation process. <strong>Xpedite</strong> by Hall Chadwick Forensics can bring clarity for the client.</p>
						<p>After inputting certain known and assumed values outlined in the statement of claim, <strong>Xpedite</strong> then produces a range of potential settlement outcomes. By doing so, <strong>Xpedite</strong> provides an opportunity for you to assist your clients to form realistic expectations.</p>

						<p><NavLink to='/register' className='btn btn--grey btn--stubby'>Request account</NavLink></p>

					</div>

				</div>

			</section>

			<section className='page__section page__section--grey'>

				<div className='wrapper wrapper--narrow clearfix'>

					<article className='page__article clearfix'>

						<div className='page__article__feature'>
							<img src={imgIcon1} alt='' />
						</div>

						<div className='page__article__content'>

							<h3>What Xpedite can do</h3>
							<ul>
								<li>Reduce the stress and anxiety for your client</li>
								<li>Empower your client to provide you with more informed instructions</li>
								<li>Continuously modify your position including change claim values and risk as necessary</li>
								<li>Print, save, share and compare positions continually throughout the litigation process</li>
							</ul>

						</div>

					</article>
					<article className='page__article clearfix'>

						<div className='page__article__feature'>
							<img src={imgIcon3} alt='' />
						</div>

						<div className='page__article__content'>

							<h3>Your confidence is assured</h3>
							<p>Each firm will be granted a login upon registration. Any matter created by the system can’t be accessed by an outside party. Once a matter is finalised it can be deleted permanently from the system.</p>
							<p>Xpedite. Settle for nothing less.</p>

						</div>

					</article>

				</div>

			</section>

			<section className='page__section page__section--padded page__section--white'>

				<div className='wrapper wrapper--narrow clearfix'>

					<div className='page__content page__content--w66 pull-left--blend'>
						<p>Hall Chadwick brings more than 38 years experience in helping businesses across Australia grow with offices are located in Australia’s major cities to assist clients anywhere around the country.</p>
					</div>

					<div className='page__sideline pull-right--blend'>
						<a className='btn btn--grey btn--stubby' href='http://www.hallchadwickmelb.com.au/' rel='noopener noreferrer' target='_blank'>Find out more</a>
					</div>

				</div>

			</section>

			<footer className='page__footer'>

				<div className='wrapper wrapper--narrow clearfix'>

					<div className='page__footer__content pull-left--blend'>
						<p>&copy; Copyright { new Date().getFullYear() } Hall Chadwick Melbourne Pty Ltd A.B.N. 88 081 186 450. All rights reserved.<br />Liability limited by a scheme approved under Professional Standards Legislation.</p>
					</div>

					<div className='page__footer__content align-centre pull-right--blend'>
						<img src={imgPrimeGlobal} alt='Prime Global' />
					</div>

				</div>

			</footer>

		</div>
	);

}


const mapStateToProps = state => {
	return {
		user: state.user
	};
}

export default connect(mapStateToProps)(home);


// WEBPACK FOOTER //
// ./src/Pages/Home.js